import axios from '../utils/axios';

export default function updateTagDetail(adminId, body) {
    return axios.post(`/admin/${adminId}/update-tags`, body);
};